import React, { Component } from "react";
import InputField from "./Elements/InputField";
import SubmitFeed from "./Elements/SubmitFeed";
import { MediaBaseUrl } from "../../../../../../../../../actions/api";
import { isAppleSafari, showAddAccountAlertNew } from "../../../../../../../../../utils";
import { addUserAccount } from "../../../../../../../../Authorization/SocialAuth/connectSocialAcc";

const channel = isAppleSafari() ? window : new BroadcastChannel('connect');

class FlickrFeed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hashtag: "",
            handle:"",
            postUrl: "",
            error: false,
            loading: false,
            errorMsg: 'This field is required',
            connetedAccount: null
        }
    }

    componentDidMount() {
        channel.addEventListener("message", this.readAuthenticationCode);
    }

    onTextChange = (e) => this.setState({ [e.target.name]: e.target.value, error: false, hashtagError: false, handleError: false });

    onAddAccount = () => {
        showAddAccountAlertNew({ id: 28, name: 'tiktok' }, "addFeed", false);
    }

    readAuthenticationCode = (event) => {
        const response = JSON.parse(event.data);
        const { data, networkId, type } = response;
        if (type == "addFeed") {
            addUserAccount(networkId, data, (accountId) => this.onSubmit(accountId), localStorage.getItem('ownerId'));
        }
    }

    onSubmit = (accountId) => {
        const { updateStep, selectedFilterId } = this.props;
        const { postUrl, connetedAccount, hashtag, handle } = this.state;

        if ((!postUrl || postUrl == "") && selectedFilterId == 70) {
            this.setState({ error: true, errorMsg: 'This field is required' });
        } else if (!postUrl.includes("://") && selectedFilterId == 70) {
            this.setState({ error: true, errorMsg: 'This field must contain a url' });
        } else if ((!hashtag || hashtag == "") && selectedFilterId == 72) {
            this.setState({ hashtagError: true });
        } else if ((!handle || handle == "") && selectedFilterId == 71) {
            this.setState({ handleError: true });
        } else {
            var obj = {
                networkId: 28,
                filter: selectedFilterId,
                moderation: 0,
                feedText: '',
                accountId: accountId ? accountId : connetedAccount,
            }

            if (selectedFilterId == 70) {
                obj['accountId'] = "";
                obj['tiktok_post_url'] = postUrl;
            }else if(selectedFilterId == 71){
                obj['accountId'] = "";
                obj['feedText'] = handle.split('@').join('');
            }else if(selectedFilterId == 72){
                obj['accountId'] = "";
                obj['feedText'] = hashtag.split('#').join('');
            }

            this.setState({ error: false, loading: true });

            updateStep(2, obj, () => this.setState({ loading: false }));
        }
    }

    componentWillUnmount() {
        channel.removeEventListener("message", this.readAuthenticationCode);
    }

    render() {
        const { postUrl, error, errorMsg, loading, hashtag, handle, hashtagError, handleError } = this.state;
        const { selectedFilterId } = this.props;
        return (
            <div className="ob-feed-form-wrapper w-100">
                {selectedFilterId == 72 ? <div className="selectSource-right mb-3">
                    <div className="position-relative d-flex custom-input">
                        <span className="hastag d-flex align-items-center">
                            <i className={`fas fa-hashtag`}></i>
                        </span>
                        <InputField name={"hashtag"} placeholder="Enter hashtag here.." className="form-control p-3" value={hashtag} onChangeHandler={(e) => this.onTextChange(e)} />
                    </div>
                    {hashtagError && <span id="feedsslackkeyworderror" className="errorMessage required text-start">This field is required</span>}
                </div> : selectedFilterId == 71 ? <div className="selectSource-right mb-3">
                    <div className="position-relative d-flex custom-input">
                        <span className="hastag d-flex align-items-center">
                            <i className={`fas fa-at`}></i>
                        </span>
                        <InputField name={"handle"} placeholder="Enter handle here.." className="form-control p-3" value={handle} onChangeHandler={(e) => this.onTextChange(e)} />
                    </div>
                    {handleError && <span id="feedsslackkeyworderror" className="errorMessage required text-start">This field is required</span>}
                </div> : selectedFilterId == 70 ? <div className="selectSource-right mb-3">
                    <div className="position-relative d-flex custom-input">
                        <span className="hastag d-flex align-items-center">
                            <i className={`fas fa-link`}></i>
                        </span>
                        <InputField name={"postUrl"} placeholder="Enter post URL here.." className="form-control p-3" value={postUrl} onChangeHandler={(e) => this.onTextChange(e)} />
                    </div>
                    {error && <span id="feedsslackkeyworderror" className="errorMessage required text-start">{errorMsg}</span>}
                </div> :
                <> <div className="form-group text-start">
                    <div className="py-2">
                        <a className="btn btn-outline-gray btn-lg w-auto btn-clean d-inline-flex align-items-center btn-lg px-3 cursor-pointer" onClick={this.onAddAccount}>
                            <span className="symbol symbol-25 me-3">
                                <img src={`${MediaBaseUrl}social-icons/tiktok.svg`} alt="tiktok" />
                            </span>
                            <span className="text-dark-50 font-weight-bolder font-size-base" onClick={this.onAddAccount} >Connect TikTok</span>
                        </a>
                    </div>
                </div>
                 { selectedFilterId == 73 ?<p style={{ fontSize: "12px", color:'#9e9c9c' }}>You will only get upcoming posts after creating mentions feed.</p> : null } </>
                }
                <div className="click-next d-flex align-items-center py-3 px-3 rounded justify-content-between">
                    <SubmitFeed loading={loading} onSubmit={this.onSubmit} onBack={this.props.backAction} disabled={selectedFilterId == 72 ? !hashtag.trim() : selectedFilterId == 71 ? !handle.trim() : selectedFilterId == 70 ? !postUrl.trim() : true} />
                </div>
            </div>
        )
    }
}

export default FlickrFeed;